import React, {Component} from 'react'
import {Button, Form, Row, Col, Table, Select, Spin, DatePicker, Tooltip} from 'antd'
import {SearchOutlined} from '@ant-design/icons'
import {getPaginationConfig} from '../../components/pagination'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import moment from 'moment'

const {RangePicker} = DatePicker

@inject('dataFlowLogStore')
@observer
class dataFlowLog extends Component {
  formRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    tableData: []
  }

  handleSearch = (pageNumber, pageSize) => {
    const {dataFlowLogStore} = this.props
    const {page, size} = this.state

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        // ...fieldsValue,
        startTime: fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[0]).format('YYYY-MM-DD HH:mm:ss') : '',
        endTime: fieldsValue?.logsTime ? moment(fieldsValue?.logsTime[1]).format('YYYY-MM-DD HH:mm:ss') : '',
        type: fieldsValue?.type,
        noticeType: fieldsValue?.noticeType,
        // users: fieldsValue?.users,
        status: fieldsValue?.status,
        page: pageNumber ? pageNumber : page,
        size: pageSize ? pageSize : size,
      }

      dataFlowLogStore.auditLogPage(params).then(res => {
        if (res?.code === 0) {
          const {records, total} = res?.data

          if (records.length > 0) {
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          } else if (records.length === 0 && total > 0 && (page !== 1 || pageNumber !== 1)) {
            this.handleSearch(page, size)
          } else if (records.length === 0 && total === 0 && (page !== 1 || pageNumber !== 1)) {
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          }else{
            this.setState({
              tableData: records,
              page: pageNumber ? pageNumber : page, // 当前页
              size: pageSize ? pageSize : size, // 每页显示条数
              total: total // 总条数
            })
          }
        }
      })
    }).catch()
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  componentDidMount() {
    this.handleSearch(1, 10)
  }

  render() {
    const {location, t, dataFlowLogStore} = this.props
    const {isFetching} = dataFlowLogStore
    const {page, size, total, tableData} = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
            <div className="searchFormTitle">
              <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div>
            <Row gutter={[10, 0]}>
              <Col span={4}>
                <Form.Item name="type" label={t(`dataFlowMonitoringConfig.dataFlowType`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key="0" value={0}>{t(`dataFlowMonitoringConfig.realTimeMonitoring`)}</Select.Option>
                    <Select.Option key="1" value={1}>{t(`dataFlowMonitoringConfig.regularMonitoring`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="noticeType" label={t(`dataFlowMonitoringConfig.notificationChannels`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key="1" value='DING_TALK_ROBOT'>{t(`dataFlowMonitoringConfig.dingding`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="status" label={t(`dataFlowLog.status`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key="0" value={0}>{t(`dataFlowLog.succes`)}</Select.Option>
                    <Select.Option key="1" value={1}>{t(`dataFlowLog.faild`)}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="logsTime" label={t(`dataFlowLog.operatingTime`)} initialValue={[moment().startOf('day'), moment().endOf('day')]}>
                  <RangePicker showTime/>
                </Form.Item>
              </Col>
              <Col span={6} style={{textAlign: 'right', marginTop: 30}}>
                <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              </Col>
            </Row>
          </Form>

          <Table className="searchResult" dataSource={tableData} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
            <Table.Column title={t(`dataFlowMonitoringConfig.dataFlowType`)} dataIndex="type" key="type" ellipsis={true} render={(text, record) => 
              text===0 ? t(`dataFlowMonitoringConfig.realTimeMonitoring`) : text===1 ? t(`dataFlowMonitoringConfig.regularMonitoring`) :null
            } />
            <Table.Column title={t(`dataFlowMonitoringConfig.notificationChannels`)} dataIndex="noticeType" key="noticeType" ellipsis={true} render={(text, record) => 
              text==='DING_TALK_ROBOT' ? t(`dataFlowMonitoringConfig.dingding`) : text
            } />
            <Table.Column title={t(`dataFlowLog.monitoringConfigName`)} dataIndex="configName" key="configName" ellipsis={true} />
            <Table.Column title={t(`dataFlowLog.requestBody`)} dataIndex="reqMsg" key="reqMsg" ellipsis={true}/>
            <Table.Column title={t(`dataFlowLog.resMsg`)} dataIndex="resMsg" key="resMsg" ellipsis={true}/>
            <Table.Column title={t(`dataFlowMonitoringConfig.notificationUser`)} dataIndex="users" key="users" ellipsis={true} render={(text, record) => (
              <Tooltip title={text?.map((a, i)=>{return i===text?.length-1 ? <p>{a?.userName}</p> : <p>{a?.userName +',' }</p>})}>
                {text?.map((a, i)=>{return i===text?.length-1 ? a?.userName : a?.userName +',' })}
              </Tooltip>
            )} />
            <Table.Column title={t(`dataFlowLog.status`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => 
              text===0 ? t(`dataFlowLog.succes`) : text===1 ? t(`dataFlowLog.faild`) :null
            } />
            <Table.Column title={t(`dataFlowLog.operatingTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          </Table>

        </div>
      </Spin>
    )
  }
}

export default withTranslation()(dataFlowLog)
